<template>

<v-dialog v-model="dialogAlbums" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <v-layout row wrap>
            <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;
            <p v-if="infoalbums.albums_name != '' && status == 'show'" class="mb-0">{{infoalbums.albums_name}} ({{filter_infoalbum.length}})</p>
            <p v-else-if="status == 'error'" class="mb-0">{{$t('Dialog.album.noAlbum')}}</p>
            <p v-else class="mb-0">{{date(infoalbums.create_date)}}</p>
          </v-layout>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="!edit && !edit_name && !delete_image && status != 'error'">
          <!-- <v-menu bottom offset-y>
            <v-btn dark icon flat slot="activator" row wrap>
              <v-icon style="font-size: 15px !important;">more_vert</v-icon>
            </v-btn>
            <v-list style="width: 165px;">
              <v-list-tile @click="edit = !edit">
                <v-icon style="font-size: 15px;">fas fa-plus-circle</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnAddImage')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="edit_name = !edit_name">
                <v-icon style="font-size: 15px;">fas fa-edit</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnEdit')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="delete_image = !delete_image">
                <v-icon style="font-size: 15px;">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnRemoveImage')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="remove">
                <v-icon style="font-size: 15px;">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnRemoveAlbum')}}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu> -->
          <header class="headerUser" style="z-index: 8 !important;" id="headerMenubarUser">
             <nav class="headerUser__nav" >
               <ul class="headerUser__navbar">
                 <li class="headerUser__item">
                   <a href="#" class="headerUser__link">
                     <button class="headerUser--btn" key="off" @click="show = !show">
                       <v-icon  class="headerUser--icon">more_vert</v-icon>
                      </button>
                   </a>
                   <transition name="dropdown">
                     <div class="headerUser__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
                       <ul class="headerUser__dropdown-menu-nav">
                         <li class="header__dropdown-menu-item" @click="clickedit()">
                           <a href="#" class="header__dropdown-menu-link">
                             <div class="header__dropdown-menu-svg">
                               <v-icon meduim class="header--icon--menu font-size15">fas fa-plus-circle</v-icon>
                             </div>
                             <div class="header__dropdown-menu-text">
                               {{$t('Dialog.album.btnAddImage')}}
                             </div>
                           </a>
                         </li>
                         <li class="header__dropdown-menu-item" @click="clickeditname()">
                           <a href="#" class="header__dropdown-menu-link">
                             <div class="header__dropdown-menu-svg">
                               <v-icon meduim class="header--icon--menu font-size15">fas fa-edit</v-icon>
                             </div>
                             <div class="header__dropdown-menu-text">
                               {{$t('Dialog.album.btnEdit')}}
                             </div>
                           </a>
                         </li>
                         <li class="header__dropdown-menu-item" @click="clickdeleteimage()">
                           <a href="#" class="header__dropdown-menu-link">
                             <div class="header__dropdown-menu-svg">
                               <v-icon meduim class="header--icon--menu font-size15">far fa-trash-alt</v-icon>
                             </div>
                             <div class="header__dropdown-menu-text">
                               {{$t('Dialog.album.btnRemoveImage')}}
                             </div>
                           </a>
                         </li>
                         <li class="header__dropdown-menu-item" @click="remove">
                           <a href="#" class="header__dropdown-menu-link">
                             <div class="header__dropdown-menu-svg">
                               <v-icon meduim class="header--icon--menu font-size15">far fa-trash-alt</v-icon>
                             </div>
                             <div class="header__dropdown-menu-text">
                               {{$t('Dialog.album.btnRemoveAlbum')}}
                             </div>
                           </a>
                         </li>
                       </ul>
                     </div>
                   </transition>
                 </li>
               </ul>
             </nav>
           </header>
        </div>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="padding-left: 30px;">
      <div v-if="edit_name" style="width: 100%; margin-bottom: 10px;">
        <v-layout row wrap align-center justify-center>
          <v-flex xs7 sm7 md7 xl7>
             <input type="text" :placeholder="$t('Dialog.album.nameAlbum')" class="CSChatThai" v-model="albumsname" />
            </v-flex>
            <v-flex xs5 sm5 md5 xl5 style="text-align: right;">
              <v-btn class="btncancel" @click="edit_name = !edit_name">{{$t('AnswerQuestion.cancel')}} </v-btn>
              <v-btn class="btnallow" @click="Edit_Name()" :loading="loading"> {{$t('AnswerQuestion.ok')}} </v-btn>
            </v-flex>
            </v-layout>
          </div>
      <v-progress-linear :indeterminate="progress" v-if="status == 'progress'"></v-progress-linear>
      <div v-else-if="status == 'show'">
        <v-layout align-center justify-start row wrap v-if="filter_infoalbum.length != 0">
          <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
            <v-layout row wrap style="max-height: 322px;background: #f3f2f2; border-radius: 5px; padding: 5px;" class="scrolling-wrapper">
              <v-flex v-for="(image,index) in filter_infoalbum" sm3 md3 lg3 xl3 style="cursor: pointer;">
                <v-card flat tile>
                  <!-- @click="zoom(image)" -->
                  <v-card-media :src="image.link" height="100px" @click="delete_image? noneF(''):zoom(image)">
                    <v-checkbox v-model="selected" :value="{'image_id':image.id, 'index': index}" style="float: right;    margin-top: 0;" color="info" v-if="delete_image"></v-checkbox>
                  </v-card-media>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout column wrap v-else align-center justify-center>
          <img src="/static/img/icons/image.png" width="150px">
          <h3>{{$t('Dialog.album.noImageAlbum')}}</h3>
        </v-layout>
        <div style="max-height:200px; min-height:100px; margin-top: 10px; word-break: break-all;" class="scrolling-wrapper">
            <div :style="edit? '': 'display:none;'">
          <form ref="fileformalbum">
        <v-flex xs12 sm12 md12 xl12  style="" class="containers hidden-sm-and-down listfile">
                <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-right: 10px;" v-if="key < 5">
                  <div style="text-align: right; padding-right: 10px;">
                  <a class="close-classic" @click="removeFile( key )"></a>
                </div>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;padding-left: 10px;padding-right: 10px;">
                    <img class="preview" v-bind:ref="'preview' + parseInt( key )" style="height: 60px !important; width:60px !important;display: flex;justify-content: center;" />
                  </div>
                </div>
                <label>
                <div :style="borderinputfile">
                     <v-icon style="color: #757575;">mdi-plus</v-icon>
                   <p style="color: #757575;">
                    {{$t('AnswerQuestion.uploadPhoto')}}
                  </p>
                   <input type="file" id="filesAlbum" ref="filesAlbum" multiple v-on:change="handleFilesAlbumUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" />
                 </div>
                 </label>

              </v-flex>
            </form>
        </div>

        </div>
        <div>
          <v-layout align-center justify-center row wrap v-if="edit">
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn dark @click="cancel" v-if="edit" class="btncancel">{{$t('AnswerQuestion.cancel')}} </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn dark @click="addimage()" v-if="edit && files.length > 0" class="btnallow" :loading="loading"> {{$t('AnswerQuestion.ok')}}
                </v-btn>
                 <v-btn disabled v-else class="btnallow" > {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row wrap v-else-if="delete_image">
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn dark @click="cancel" v-if="delete_image" class="btncancel">{{$t('AnswerQuestion.cancel')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn dark @click="deleteimage()" v-if="delete_image" class="btnallow" :loading="loading"> {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-else-if="status == 'error'" style="text-align: center;">
        <br>
        <v-icon style="color: #757575 !important; font-size: 80px !important;">error_outline</v-icon>
        <br><br>
        <p style="font-size: 20px; color: #757575;"> {{errormessage}} </p>
      </div>
    </v-card-text>


  </v-card>
  <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
</v-dialog>
<!-- <v-dialog v-model="dialogAlbums" v-else></v-dialog> -->
</template>
<script>
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { Momenttime, Decode } from '@/services'
var _ = require('lodash')
export default {
  props: {
    dialogAlbums: false,
    albums_id: ''
  },
  data: () => ({
    dataalbums: {
      note_data: {
        text: ''
      }
    },
    show: false,
    token: '',
    edit: false,
    edittext: '',
    preedittext: '',
    progress: true,
    status: 'show',
    errormessage: '',
    infoalbums: [],
    albumsname: '',
    files: [],
    edit_name: false,
    add_image: false,
    new_name: '',
    loading: false,
    delete_image: false,
    selected: [],
    filter_infoalbum: [],
    path_pic: '',
    picSend: '',
    nicknameSend: '',
    filenameSend: '',
    dateSend: '',
    timeSend: '',
    tokenmsgSend: '',
    pathSend: '',
    typeuserSend: '',
    typeuser: '',
    pathpicture: '',
    typepathpicture: '',
    dialogshowimage_profile: false,
    dragAndDropCapable: false,
    borderinputfile: 'text-align:center;border: 1px solid #00000036; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-right: 10px; cursor: pointer;padding-top: 23px;',
    normal: 'text-align:center; border-radius: 5px; width: 100px !important; height: 100px !important; position: relative; background: white;justify-content: center; margin-right: 10px; cursor: pointer;padding-top: 23px;'
  }),
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  components: {
    ShowImageProfileDialog
  },
  methods: {
    clickedit () {
      this.edit = !this.edit
      this.show = false
    },
    clickeditname () {
      this.edit_name = !this.edit_name
      this.show = false
    },
    clickdeleteimage () {
      this.delete_image = !this.delete_image
      this.show = false
    },
    determineDragAndDropCapable () {
      // console.log('determineDragAndDropCapable')
        var div = document.createElement('div')
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
      },
    dateMoment (data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment (data) {
      return Momenttime.momenttimethai(data)
    },
    zoom (item) {
      // console.log(item)
      this.pathpicture = item.link
      this.typepathpicture = 'none'
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    deleteimage () {

      var imageid = []
      var index_image = []
      for (var i = 0; i < this.selected.length; i++) {
        imageid[i] = this.selected[i]['image_id']
        index_image[i] = this.selected[i]['index']
      }
      if (this.selected.length !== 0) {
        this.$swal({
          text: this.$t('Alert.Album.deleteImage'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          // console.log(result.value)
          if (result.value) {
            this.loading = true
            this.axios.post(process.env.APIpub + '/delete_image_albums' , {
              tokenuser: this.token,
              tokenroom: this.$route.params.roomid,
              albums_id: this.albums_id,
              images_id: imageid
            }).then((response) => {
              this.loading = false
              for (var i = 0; i < index_image.length; i++) {
                var index = this.selected[i]['index']
                // console.log(this.filter_infoalbum[index]['status'])
                this.filter_infoalbum[index]['status'] = 'delete'
              }
              // localStorage.setItem('albums_id', this.albums_id)
              this.filter_infoalbum = _.filter(this.filter_infoalbum, function (filter_infoalbum) { return filter_infoalbum.status === 'active' })
              this.$emit('editAlbums', {'event': 'delete_image', 'albums_id': this.albums_id, 'index_image': index_image, 'image_id': imageid})
              this.$swal('', this.$t('Alert.Success.removePhoto'), 'success')
              this.selected = []
              imageid = []
              index_image = []
              this.delete_image = false
            })
          } else {
            console.log('else')
            this.selected = []
            imageid = []
            index_image = []
            this.delete_image = false
          }
        })
      } else {
        this.$swal('', this.$t('Alert.Fail.Album.minFiles'), 'warning')
      }
    },
    addimage () {
      let formData = new FormData()
      var lengthfile = this.files.length
      var sizealums = []
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file
        formData.append('file[]', file, file.name)
        sizealums[i] = this.files[i].file.size
        // console.log(file)
      }
      if (_.sum(sizealums)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' })
        this.files = []
        this.loading = false
      } else {
        this.loading = true
        formData.append('tokenuser', this.token)
        formData.append('tokenroom', this.$route.params.roomid)
        formData.append('albums_id', this.albums_id)
        this.axios.post(process.env.APIpub + '/addimage_albums', formData).then((response) => {
          this.loading = false
          var infoalbums = {}
          infoalbums = response.data.data.image_add
          this.$swal('', this.$t('Alert.Success.savePhotoAlbum'), 'success')
          this.files = []
          this.edit = false
          this.$emit('closeAlbums', false)
        }, () => {
          this.loading = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    },
    Edit_Name () {
      this.new_name = this.albumsname
      this.loading = true
      this.axios.post(process.env.APIpub + '/edit_albums_name', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        albums_id: this.albums_id,
        new_name: this.new_name
      }).then((response) =>{
        // console.log(response.data)
        if (response.data.status) {
          this.loading = false
          this.$swal(
            '',
            this.$t('Alert.Success.renameAlbum'),
            'success'
          )
          this.infoalbums.albums_name = this.new_name
          this.edit_name = false
          this.$emit('editAlbums', {'event': 'edit_name', 'albums_name': this.albumsname, 'albums_id': this.albums_id})
        } else {
          this.loading = false
          this.$swal(
            '',
            this.$t('Alert.Fail.default.somethingWrong'),
            'warning'
          )
        }
      }).catch(err => {
        // console.log(err)
        this.loading = false
        if (err.response.data.message === 'New albums name cannot null.') {
          this.$swal(
            '',
            this.$t('Alert.Fail.Album.emptyName'),
            'warning'
          )
        }
      })
    },
    closeDialog() {
      this.$emit('closeAlbums', false)
      this.edit = false
      this.edit_name = false
      this.delete_image = false
      this.files = []
    },
    remove() {
        this.show = false
        this.$swal({
          text: this.$t('Alert.Album.deleteAlbum'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/delete_albums', {
            albums_id: this.albums_id,
            tokenuser: this.token,
            tokenroom: this.$route.params.roomid
          }).then((response) => {
            if (response.data.status === 'success') {
              this.status = 'error'
              this.errormessage = this.$t('Alert.Fail.Album.removed')
              this.$emit('removeAlbums', this.albums_id)
              this.closeDialog()
            } else {
              this.$swal(
                '',
                this.$t('Alert.Fail.default.somethingWrong'),
                'error'
              )
            }
          })
        }
      })
    },
    save() {
      this.edit = false
      if (this.edittext !== this.preedittext) {
        this.dataalbums.note_data.text = this.edittext
        this.preedittext = this.edittext
        this.axios.post(process.env.APImanage + '/editnote', {
          note_id: this.note_id,
          tokenuser: this.token,
          text: this.edittext
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.$emit('editNote', this.edittext, this.note_id)
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          }
        }, () => {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    },
    cancel() {
      this.selected = []
      this.edit = false
      this.files = []
      this.add_image = false
      this.delete_image = false
      this.edittext = this.preedittext
    },
    date(timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time(timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    convert(msg) {
      var text = msg
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig
      var text1 = text.replace(/</g, '&lt;')
      var text2 = text1.replace(/>/g, '&gt;')
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>')
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>')
      return text4
    },
    extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
      // return extension[extension.length-1]
    },
    uppic () {
      $('#filesAlbum').click()
    },
    handleFilesAlbumUpload(key) {
      // console.log('handleFilesAlbumUpload')
      let uploadedFiles = this.$refs.filesAlbum.files
      // console.log(uploadedFiles)
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        })
      }
      this.getImagePreviews(key)
      document.querySelector('#filesAlbum').value = ''
    },
    removeFile(key) {
      this.files.splice(key, 1)
      this.getImagePreviews(key)
    },
    getImagePreviews(key) {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function() {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
          }.bind(this), false)
          reader.readAsDataURL(this.files[i].file)
        } else {
          this.removeFile(i)
          alert(this.$t('Alert.Fail.Album.supportType'))
        }
      }
    },
    noneF (value) {

    }
  },
  watch: {
    edit () {
      // console.log(this.selected)
      if (this.edit) {
        this.dragAndDropCapable = this.determineDragAndDropCapable()
        var me = this
        // console.log(this.dragAndDropCapable)
        if (this.dragAndDropCapable) {
          ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
            this.$refs.fileformalbum.addEventListener(evt, function (e) {
              e.preventDefault()
              e.stopPropagation()
            })
          }.bind(this))
          this.$refs.fileformalbum.addEventListener('dragover', function (e) {
            // console.log('dragover')
            this.borderinputfile = this.normal + 'border: 2px dotted #00000036;'
          }.bind(this))
          this.$refs.fileformalbum.addEventListener('dragleave', function (e) {
            // console.log('dragleave')
            this.borderinputfile = this.normal + 'border: 1px solid #00000036;'
          }.bind(this))
          this.$refs.fileformalbum.addEventListener('drop', function (e) {
            // console.log('drop')
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
              this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
              this.getImagePreviews()
              this.borderinputfile = this.normal + 'border: 1px solid #00000036;'
              // }
            }
          }.bind(this))
        }
      }
    },
    files () {
      if (this.files.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.Album.maxFiles'),
          'warning'
        )
        _.pullAt(this.files, [5])
      }
    },
    dialogAlbums() {
      // console.log(this.albums_id)
      if (this.dialogAlbums) {
        // this.dataalbums.note_data.text = 'test'
        this.progress = true
        this.status = 'progress'
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: this.albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.progress = false
          this.status = 'show'
          this.infoalbums = response.data.data
          this.albumsname = this.infoalbums.albums_name
          this.filter_infoalbum = _.filter(this.infoalbums.information, function (information) { return information.status === 'active' })
        }).catch((error) => {
          this.status = 'error'
          if (error.response.data.status === 'fail') {
            this.errormessage = this.$t('Alert.Fail.Album.removed')
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.font-size15 {
  font-size: 15px !important;
}
>>>.theme--light.v-icon .v-checkbox {
    color: #2196f3 !important;
}
>>>.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}

.btnallow {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.btncancel {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 4px !important;
  background: #e0e0e0 !important;
  color: black !important;
  text-transform: none;
}

.scrolling-wrapper {
  display: flex;
  overflow-y: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=textadd] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 12px 12px 12px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 110px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding: 5px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 150px !important;
  height: 100px !important;
  position: relative;
  background: white;
}
/* The Modal (background) */
.modalc-albums-web {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw;
  /* Full width */
  height: 100vh;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9);
  /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
.modal-contentc-albums-web {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

#headcaptionalbumsweb {
  margin: auto;
  display: block;

  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  background-color: #1b232d;
  /*height: 150px;*/
}

/* Add Animation - Zoom in the Modal */
/*.modal-contentc-albums-web {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/

@keyframes zoom {
  from {
    transform: scale(0)
  }

  to {
    transform: scale(1)
  }
}

/* The Close Button */
.closealbumsweb {
  position: absolute;
  top: 0vh;
  right: 35px;
  color: white;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.closealbumsweb:hover,
.closealbumsweb:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-contentc-albums-web {
    width: 100vw;
  }
}


.wrapper {
  position: relative;
  /*display: inline-block;*/
}
input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}



.headerOut__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 4rem;
  min-width: 170px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.headerOut__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerOut__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerOut__dropdown-menu-link:hover .headerOut--icon--menu {
  color: #2562af;
}
.headerOut__dropdown-menu-svg {
  padding-right: 16px;
}
.headerOut__dropdown-menu-svg.headerOut--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerOut__dropdown-menu-svg.headerOut--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.header__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 25rem;
  min-width: 215px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.header__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
  width: 170px;
}
.header__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.header__dropdown-menu-link:hover .header--icon--menu {
  color: #2562af;
}
.header__dropdown-menu-svg {
  padding-right: 16px;
}
.header__dropdown-menu-svg.header--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.header__dropdown-menu-svg.header--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.headerUser {
  margin-top: 15px;
}

.headerUser__nav {
  position: relative;
}
.headerUser__navbar {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.headerUser__item {
  padding: 1rem;
  position: relative;
}
.headerUser--icon {
  font-size: 20px;
  color: white !important;
}
.headerUser--icon--menu {
  color: gray;
}
.headerUser--btn {
  top: 0;
  right: 0;
  position: absolute;
}
.headerUser--btn:focus {
  outline:none;
}
.headerUser--icon, .headerUser--icon--menu {
  fill: currentcolor;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
.headerUser--btn {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  border: 1px solid transparent;
  background-color: transparent;
  appearance: none;
  user-select: none;
}
.headerUser__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  height: 10rem;
  width: 175px;
  overflow-y: auto;
  padding: 7px 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
  /* justify-content: center; */
  display: flex;
  align-items: center;
}
.headerUser__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerUser__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerUser__dropdown-menu-link:hover .headerUser--icon--menu {
  color: #2562af;
}
.headerUser__dropdown-menu-svg {
  padding-right: 16px;
}
.headerUser__dropdown-menu-svg.headerUser--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerUser__dropdown-menu-svg.headerUser--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}

/*// Dropdown animation*/
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.wrapper {
  height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.wrapper.social {
  margin-top: 1rem;
}
.wrapper a {
  padding: 0.6rem;
}
.wrapper h1 {
  color: #42b983;
  font-size: 2rem;
  font-weight: 300;
}
.wrapper p {
  color: #7f8c8d;
  font-weight: 100;
}
.wrapper svg {
  fill: currentcolor;
  color: #b8c2cc;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/albums/AlbumsDialog.vue